
import { WorldCountry } from '../types';

export const southKoreaExpanded: WorldCountry = {
  name: 'South Korea',
  slug: 'south-korea',
  code: 'KR',
  population: 51780579,
  topCities: [
    { name: 'Seoul', slug: 'seoul', population: 9720846 },
    { name: 'Busan', slug: 'busan', population: 3448737 },
    { name: 'Incheon', slug: 'incheon', population: 2954955 },
    { name: 'Daegu', slug: 'daegu', population: 2466052 },
    { name: 'Daejeon', slug: 'daejeon', population: 1538394 },
    { name: 'Gwangju', slug: 'gwangju', population: 1469214 },
    { name: 'Suwon', slug: 'suwon', population: 1194313 },
    { name: 'Ulsan', slug: 'ulsan', population: 1166615 },
    { name: 'Changwon', slug: 'changwon', population: 1059241 },
    { name: 'Goyang', slug: 'goyang', population: 1073069 },
    
    // Expansión: 90 ciudades adicionales
    { name: 'Yongin', slug: 'yongin', population: 971327 },
    { name: 'Seongnam', slug: 'seongnam', population: 948757 },
    { name: 'Bucheon', slug: 'bucheon', population: 843794 },
    { name: 'Cheongju', slug: 'cheongju', population: 834340 },
    { name: 'Ansan', slug: 'ansan', population: 747035 },
    { name: 'Jeonju', slug: 'jeonju', population: 658172 },
    { name: 'Anyang', slug: 'anyang', population: 601854 },
    { name: 'Cheonan', slug: 'cheonan', population: 588815 },
    { name: 'Namyangju', slug: 'namyangju', population: 674651 },
    { name: 'Pohang', slug: 'pohang', population: 516577 },
    { name: 'Uijeongbu', slug: 'uijeongbu', population: 450000 },
    { name: 'Siheung', slug: 'siheung', population: 478254 },
    { name: 'Hwaseong', slug: 'hwaseong', population: 962369 },
    { name: 'Gimhae', slug: 'gimhae', population: 544635 },
    { name: 'Gumi', slug: 'gumi', population: 420479 },
    { name: 'Pyeongtaek', slug: 'pyeongtaek', population: 551500 },
    { name: 'Gunsan', slug: 'gunsan', population: 268402 },
    { name: 'Iksan', slug: 'iksan', population: 283501 },
    { name: 'Mokpo', slug: 'mokpo', population: 233732 },
    { name: 'Suncheon', slug: 'suncheon', population: 280719 },
    { name: 'Jeju', slug: 'jeju', population: 486788 },
    { name: 'Yeosu', slug: 'yeosu', population: 282946 },
    { name: 'Gangneung', slug: 'gangneung', population: 213658 },
    { name: 'Wonju', slug: 'wonju', population: 364860 },
    { name: 'Chuncheon', slug: 'chuncheon', population: 283480 },
    { name: 'Sokcho', slug: 'sokcho', population: 83023 },
    { name: 'Samcheok', slug: 'samcheok', population: 68570 },
    { name: 'Hongcheon', slug: 'hongcheon', population: 69435 },
    { name: 'Hoengseong', slug: 'hoengseong', population: 44556 },
    { name: 'Yeongwol', slug: 'yeongwol', population: 39169 },
    { name: 'Pyeongchang', slug: 'pyeongchang', population: 43395 },
    { name: 'Jeongseon', slug: 'jeongseon', population: 38902 },
    { name: 'Cheorwon', slug: 'cheorwon', population: 46265 },
    { name: 'Hwacheon', slug: 'hwacheon', population: 24051 },
    { name: 'Yanggu', slug: 'yanggu', population: 20729 },
    { name: 'Inje', slug: 'inje', population: 31255 },
    { name: 'Goseong', slug: 'goseong-gangwon', population: 27806 },
    { name: 'Yangyang', slug: 'yangyang', population: 28336 },
    { name: 'Chungju', slug: 'chungju', population: 208286 },
    { name: 'Jecheon', slug: 'jecheon', population: 134724 },
    { name: 'Danyang', slug: 'danyang', population: 29490 },
    { name: 'Eumseong', slug: 'eumseong', population: 98351 },
    { name: 'Jincheon', slug: 'jincheon', population: 87018 },
    { name: 'Goesan', slug: 'goesan', population: 37000 },
    { name: 'Boeun', slug: 'boeun', population: 33000 },
    { name: 'Okcheon', slug: 'okcheon', population: 51000 },
    { name: 'Yeongdong', slug: 'yeongdong', population: 47000 },
    { name: 'Asan', slug: 'asan', population: 323000 },
    { name: 'Seosan', slug: 'seosan', population: 175000 },
    { name: 'Nonsan', slug: 'nonsan', population: 120000 },
    { name: 'Gyeryong', slug: 'gyeryong', population: 45000 },
    { name: 'Dangjin', slug: 'dangjin', population: 168000 },
    { name: 'Gongju', slug: 'gongju', population: 106000 },
    { name: 'Buyeo', slug: 'buyeo', population: 62000 },
    { name: 'Seocheon', slug: 'seocheon', population: 55000 },
    { name: 'Cheongyang', slug: 'cheongyang', population: 31000 },
    { name: 'Hongseong', slug: 'hongseong', population: 101000 },
    { name: 'Yesan', slug: 'yesan', population: 81000 },
    { name: 'Taean', slug: 'taean', population: 63000 },
    { name: 'Boryeong', slug: 'boryeong', population: 103000 },
    { name: 'Gimcheon', slug: 'gimcheon', population: 139000 },
    { name: 'Andong', slug: 'andong', population: 167000 },
    { name: 'Gyeongju', slug: 'gyeongju', population: 254000 },
    { name: 'Yeongju', slug: 'yeongju', population: 108000 },
    { name: 'Yeongcheon', slug: 'yeongcheon', population: 99000 },
    { name: 'Sangju', slug: 'sangju', population: 102000 },
    { name: 'Mungyeong', slug: 'mungyeong', population: 73000 },
    { name: 'Yecheon', slug: 'yecheon', population: 52000 },
    { name: 'Chilgok', slug: 'chilgok', population: 121000 },
    { name: 'Seongju', slug: 'seongju', population: 44000 },
    { name: 'Gunwi', slug: 'gunwi', population: 23000 },
    { name: 'Uiseong', slug: 'uiseong', population: 54000 },
    { name: 'Cheongsong', slug: 'cheongsong', population: 25000 },
    { name: 'Yeongyang', slug: 'yeongyang', population: 17000 },
    { name: 'Yeongdeok', slug: 'yeongdeok', population: 38000 },
    { name: 'Bonghwa', slug: 'bonghwa', population: 32000 },
    { name: 'Uljin', slug: 'uljin', population: 48000 },
    { name: 'Ulju', slug: 'ulju', population: 231000 },
    { name: 'Jinju', slug: 'jinju', population: 341000 },
    { name: 'Tongyeong', slug: 'tongyeong', population: 132000 },
    { name: 'Sacheon', slug: 'sacheon', population: 115000 },
    { name: 'Gimhae', slug: 'gimhae-alt', population: 545000 },
    { name: 'Miryang', slug: 'miryang', population: 107000 },
    { name: 'Geoje', slug: 'geoje', population: 247000 },
    { name: 'Yangsan', slug: 'yangsan', population: 361000 },
    { name: 'Uiryeong', slug: 'uiryeong', population: 27000 },
    { name: 'Haman', slug: 'haman', population: 66000 },
    { name: 'Changnyeong', slug: 'changnyeong', population: 61000 },
    { name: 'Goseong', slug: 'goseong-gyeongnam', population: 55000 },
    { name: 'Namhae', slug: 'namhae', population: 42000 },
    { name: 'Hadong', slug: 'hadong', population: 46000 },
    { name: 'Sancheong', slug: 'sancheong', population: 34000 },
    { name: 'Hamyang', slug: 'hamyang', population: 41000 },
    { name: 'Geochang', slug: 'geochang', population: 60000 },
    { name: 'Hapcheon', slug: 'hapcheon', population: 46000 }
  ]
};
